import { createSelector } from '@reduxjs/toolkit';

import { authSelectors } from '../auth';
import { sharesSelectors } from '../shares';
import type { Share } from '../shares/types';
import { isMcpClientId } from './mcpClientsUtils';

const ACTIVE_SHARE_STATE = 'ACTIVE';

export const getMcpShares = createSelector(
  [sharesSelectors.getSharesById, authSelectors.getDatasetId],
  (shares, datasetId): Share[] =>
    shares
      .toList()
      .filter(
        (share) =>
          isMcpClientId(share.clientId) &&
          share.state === ACTIVE_SHARE_STATE &&
          !share.isDeleted &&
          (!datasetId || share.datasetId === datasetId),
      )
      .sortBy((share) => share.clientId)
      .toArray(),
);

export const getHasMcpShares = createSelector([getMcpShares], (mcpShares) => mcpShares.length > 0);
